var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoResults(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 333,
    height: 305,
    viewBox: "0 0 333 305",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M285.364 105.521H39.095C37.42 101.333 35.074 91.113 39.095 83.742C43.116 76.371 55.848 72.853 61.712 72.015C58.082 69.502 51.272 55.509 61.712 43.404C70.381 33.352 88.796 36.554 96.893 39.347C95.497 34.6 98.023 22.965 108.075 18.275C120.64 12.411 128.444 21.198 133.749 25.106C135.983 15.334 148.157 -2.87099 178.982 2.49001C203.567 6.76601 211.371 29.295 208.3 39.347C210.534 33.204 237.911 25.106 261.91 39.347C290.767 56.47 293.182 89.606 285.364 105.521Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.38571
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M320.004 131.354H215.297C208.876 126.887 197.874 114.937 205.246 102.874C212.617 90.811 235.68 90.588 246.29 91.985C253.829 84.725 263.546 71.549 282.309 73.56C301.073 75.57 310.789 93.66 308.277 102.874C312.186 101.478 321.846 101.031 329.218 110.413C336.589 119.795 326.146 128.283 320.004 131.354Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.38571
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.249 209.415L2.32001 153.219L108.402 256.447L107.249 209.415Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.38571
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M137.239 183.256L2.32001 153.219L107.249 209.415L137.239 183.256Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.38571
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.777 256.009L76.195 235.763L89.286 223.257C90.471 222.125 92.42 222.498 93.103 223.989L107.777 256.009Z",
    fill: "#D6E4FF",
    stroke: "black",
    strokeWidth: 2.38571
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.128 258.132L1.69501 152.781L91.269 221.571L52.128 258.132Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.38571
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M111.43 260.355C113.105 271.524 124.329 293.694 155.825 293.024C187.321 292.354 196.311 279.342 196.87 272.92C198.545 266.777 198.21 253.152 183.467 247.791C165.039 241.089 160.934 260.982 163.364 267.057C165.039 271.245 167.552 283.809 201.896 298.887C229.371 310.949 256.901 296.095 267.232 287.16",
    stroke: "black",
    strokeWidth: 2.38571,
    strokeDasharray: "7.16 7.16"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResults);
export default __webpack_public_path__ + "static/media/noResults.9082785253fd72c3d3ab5e1c5f75da93.svg";
export { ForwardRef as ReactComponent };